import { BlockModule } from '@/website/blocks/common'
import GlobalGlobe from './components/GlobalGlobe.vue'

new BlockModule({
    selector: '.block-global-globe',
    vueComponent: GlobalGlobe,
})
